export default "__VITE_ASSET__DL23NB$m__"